<!-- THE one global action toast (FE-53; MYDAY_LEAD_COMMS_PLAN.md Appendix C.9). Design: Trovve.dc.html D:5916 (the lead /
     stage-move toast), D:4813-4814 (the status pill), D:551-557 (the Undo button), Icon.dc.html:102 (rotate-ccw). The
     wrapper is always in the DOM: it is the polite live region and it carries the centring; the card inside carries the
     look (and, for the status pill, the pop). Every value is precomputed in ActionToastView: no logic here. -->
<div class="vf-atoast" [class.vf-atoast--status]="isStatus" role="status" aria-live="polite" aria-atomic="true">
    <div
        #card
        *ngIf="view as v"
        class="vf-atoast__card"
        [ngClass]="v.cardClass"
        (mouseenter)="onPointerEnter()"
        (mouseleave)="onPointerLeave()"
        (focusin)="onFocusIn()"
        (focusout)="onFocusOut($event)"
    >
        <svg *ngIf="v.showCheck" class="vf-atoast__icon vf-atoast__icon--check" width="15" height="15" viewBox="0 0 24 24"
            fill="none" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M20 6 9 17l-5-5"/></svg>
        <svg *ngIf="v.isStatus" class="vf-atoast__icon vf-atoast__icon--clock" width="15" height="15" viewBox="0 0 24 24"
            fill="none" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>
        <span class="vf-atoast__text">
            <span class="vf-atoast__title">{{ v.title }}</span>
            <span *ngIf="v.hasSub" class="vf-atoast__sub">{{ v.sub }}</span>
        </span>
        <button *ngIf="v.action as a" type="button" class="vf-atoast__action" [disabled]="a.busy" (click)="onAction($event)">
            <svg *ngIf="a.showUndoIcon" class="vf-atoast__undo" width="14" height="14" viewBox="0 0 24 24" fill="none"
                stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8"/><path d="M3 3v5h5"/></svg>{{ a.label }}
        </button>
    </div>
</div>
